const PICKER_SELECTOR = '.workflow-event-picker';

const activeDimension = (picker) => picker.querySelector('.dimension-tab.active')?.dataset.dimension ?? 'order';

const matchesQuery = (item, query) => {
    if (query === '') {
        return true;
    }

    const haystack = [
        item.querySelector('h4').textContent,
        item.querySelector('p').textContent,
        item.querySelector('.category').textContent,
    ].join(' ').toLowerCase();

    return haystack.includes(query);
};

const applyFilter = (picker) => {
    const dimension = activeDimension(picker);
    const query     = picker.querySelector('[name="query"]').value.trim().toLowerCase();
    const items     = picker.querySelectorAll('li[data-slug]');

    let visible = 0;
    let total   = 0;

    items.forEach((item) => {
        const inDimension = item.dataset.dimension === dimension;

        total += inDimension ? 1 : 0;

        const show = inDimension && matchesQuery(item, query);

        item.hidden = !show;
        visible += show ? 1 : 0;
    });

    const countElement = picker.querySelector('.count');

    countElement.textContent = countElement.dataset.countTemplate
        .replace('%d', visible)
        .replace('%d', total)
    ;

    picker.querySelector('.no-results').hidden = visible !== 0;
    picker.querySelector('[data-clear-search]').hidden = query === '';
};

const selectEvent = (picker, item) => {
    const hidden        = picker.querySelector('input[name="targetEvent"]');
    const alreadyChosen = item.classList.contains('selected');

    picker.querySelectorAll('li.selected').forEach((selected) => selected.classList.remove('selected'));

    if (!alreadyChosen) {
        item.classList.add('selected');
    }

    hidden.value = alreadyChosen ? '' : item.dataset.slug;

    picker.classList.remove('is-invalid');

    hidden.dispatchEvent(new Event('change', {bubbles: true}));
};

const switchDimension = (picker, tab) => {
    if (tab.classList.contains('active')) {
        return;
    }

    picker.querySelectorAll('.dimension-tab').forEach((other) => other.classList.remove('active'));
    tab.classList.add('active');

    const hidden   = picker.querySelector('input[name="targetEvent"]');
    const selected = picker.querySelector('li.selected');

    if (selected && selected.dataset.dimension !== tab.dataset.dimension) {
        selected.classList.remove('selected');
        hidden.value = '';
    }

    picker.querySelector('[name="query"]').value = '';

    applyFilter(picker);
};

const revealCustomizeName = (button) => {
    const box = button.parentElement.querySelector('[data-customize-name-box]');

    box.hidden = false;
    button.hidden = true;

    box.querySelector('[name="title"]')?.focus();
};

const initialize = (picker) => {
    const selected = picker.querySelector('li.selected');

    if (selected) {
        const tab = picker.querySelector(`.dimension-tab[data-dimension="${selected.dataset.dimension}"]`);

        picker.querySelectorAll('.dimension-tab').forEach((other) => other.classList.remove('active'));
        tab?.classList.add('active');
    }

    applyFilter(picker);

    selected?.scrollIntoView({block: 'nearest'});

    const form  = picker.closest('form');
    const title = form?.querySelector('[name="title"]');

    if (title && title.value.trim() !== '') {
        form.querySelector('[data-customize-name-box]').hidden = false;
        form.querySelector('[data-customize-name-toggle]').hidden = true;
    }
};

export const initializeEventPickers = () => document.querySelectorAll(PICKER_SELECTOR).forEach(initialize);

document.addEventListener('sidepanel:open', initializeEventPickers);

document.addEventListener('click', (event) => {
    const tab = event.target.closest(`${PICKER_SELECTOR} .dimension-tab`);

    if (tab) {
        switchDimension(tab.closest(PICKER_SELECTOR), tab);

        return;
    }

    const clear = event.target.closest(`${PICKER_SELECTOR} [data-clear-search]`);

    if (clear) {
        const picker = clear.closest(PICKER_SELECTOR);

        picker.querySelector('[name="query"]').value = '';
        applyFilter(picker);

        return;
    }

    const customizeToggle = event.target.closest('[data-customize-name-toggle]');

    if (customizeToggle) {
        revealCustomizeName(customizeToggle);

        return;
    }

    const item = event.target.closest(`${PICKER_SELECTOR} li[data-slug]`);

    if (item) {
        selectEvent(item.closest(PICKER_SELECTOR), item);
    }
});

document.addEventListener('input', (event) => {
    const searchField = event.target.closest(`${PICKER_SELECTOR} [name="query"]`);

    if (searchField) {
        applyFilter(searchField.closest(PICKER_SELECTOR));
    }
});
